module.exports = __webpack_public_path__ + "img/g-colored.dc368323.png";